/**
 * Common Translations Module (Portuguese)
 * Matches English structure exactly
 * @module common
 * @language pt
 */

export const common = {
  nav: {
    // 1. Overview (standalone)
    overview: "Visão Geral",
    
    // 2. Youth Futures (dropdown parent)
    youthFutures: "Futuros da Juventude",
    // Youth Futures dropdown items
    impactMetrics: "Impacto e Métricas",
    mentalHealth: "Dimensão Saúde Mental",
    workforceEducation: "Força de Trabalho e Educação",
    entrepreneurshipSupport: "Dimensão Empreendedorismo",
    
    // 3. Database (dropdown parent)
    database: "Base de Dados",
    // Database dropdown items
    memberInsights: "Insights de Membros",
    programsEvents: "Programas e Eventos",
    technologyFuture: "Tecnologia e Futuro",
    regionalAnalysis: "Análise Regional",
    
    // 4. Vision 2040 (standalone)
    vision2040: "Visão 2040",
    
    // 5. Know More (dropdown parent)
    knowMore: "Saiba Mais",
    // Know More dropdown items
    methodology: "Metodologia",
    contributing: "Contribuir",
    faq: "Perguntas Frequentes",
    
    // Additional nav items
    backToTop: "Voltar ao topo",
    brandName: "JCI Vision Pulse",
    observatoryTitle: "Observatório de Futuros da Juventude"
  },
  footer: { copyright: "© 2025 Conselhos de Desenvolvimento JCI. Licenciado sob CC BY-NC-SA.", methodology: "Metodologia baseada em dados de 147.424 membros JCI globalmente.", poweredBy: "Desenvolvido por", privacyPolicy: "Política de Privacidade", termsOfService: "Termos de Serviço" },
  settings: { title: "Configurações", subtitle: "Gerencie suas preferências e personalize sua experiência.", appearance: "Aparência", appearanceDescription: "Personalize como o observatório aparece no seu dispositivo.", light: "Claro", dark: "Escuro", system: "Sistema", language: "Idioma", languageDescription: "Selecione seu idioma preferido para a interface.", notifications: "Notificações", notificationsDescription: "Configure como deseja receber atualizações e alertas.", emailNotifications: "Notificações por Email", emailNotificationsDescription: "Receba atualizações e relatórios por email.", pushNotifications: "Notificações Push", pushNotificationsDescription: "Receba alertas em tempo real no seu navegador.", productUpdates: "Atualizações de Produto", productUpdatesDescription: "Mantenha-se informado sobre novos recursos e melhorias.", preferencesUpdated: "Preferências atualizadas", notificationsEnabled: "notificações ativadas", notificationsDisabled: "notificações desativadas", themeUpdated: "Tema atualizado", themeChangedTo: "Tema alterado para", languageUpdated: "Idioma atualizado", languageChangedTo: "Idioma alterado para", profile: "Seu Perfil", profileDescription: "Informações da sua conta", clickToChangeAvatar: "Clique no avatar para alterar", avatar: { error: "Erro", loginRequired: "Você precisa estar logado para enviar um avatar", invalidType: "Tipo de arquivo inválido", selectImage: "Por favor, selecione um arquivo de imagem", tooLarge: "Imagem muito grande", selectSmaller: "Por favor, selecione uma imagem menor (máx 100KB após compressão)", updated: "Avatar atualizado", updatedSuccess: "Sua foto de perfil foi atualizada com sucesso", uploadFailed: "Falha no upload", failedToUpload: "Falha ao enviar o avatar" }, observatoryLens: "Lente do Observatório", observatoryLensDescription: "Suas preferências personalizadas de foco de dados", primaryInterest: "Interesse Principal", focusCountry: "País de Foco", refineLens: "Refinar Lente do Observatório", translationDebug: "Depurador de Tradução", translationDebugDescription: "Visualize chaves de tradução ausentes e status de conclusão", dangerZone: "Zona de Perigo", dangerZoneDescription: "Ações irreversíveis que afetam sua conta", deleteAccount: "Excluir Conta", deleteAccountDescription: "Exclua permanentemente sua conta e todos os dados associados", deleteAccountConfirmTitle: "Excluir sua conta?", deleteAccountConfirmDescription: "Esta ação não pode ser desfeita. Todos os seus dados serão permanentemente excluídos, incluindo:", deleteAccountDataProfile: "Suas informações de perfil", deleteAccountDataNotifications: "Preferências e histórico de notificações", deleteAccountDataAvatar: "Sua foto de perfil", deleteAccountDataProgress: "Progresso e conquistas do observatório", typeEmailConfirm: "Digite seu email para confirmar:", deleteAccountButton: "Excluir Minha Conta Permanentemente", accountDeleted: "Conta Excluída", accountDeletedDescription: "Sua conta e todos os dados associados foram permanentemente excluídos.", deleteFailed: "Falha na Exclusão", deleteFailedDescription: "Não foi possível excluir sua conta. Tente novamente ou entre em contato com o suporte.", emailMismatch: "Email não corresponde", privacyData: "Privacidade e Dados", privacyDataDescription: "Gerencie seus dados pessoais e configurações de privacidade", downloadData: "Baixar Seus Dados", downloadDataDescription: "Exporte todos os seus dados pessoais em formato JSON (perfil, notificações, preferências)", downloadAsJson: "Baixar como JSON", downloading: "Preparando download...", downloadComplete: "Download Concluído", downloadCompleteDescription: "Seus dados pessoais foram baixados com sucesso.", downloadFailed: "Falha no Download", downloadFailedDescription: "Não foi possível exportar seus dados. Tente novamente.", cancel: "Cancelar", processingRecord: { title: "Registro de Processamento de Dados", activitiesRecorded: "atividades de processamento registradas", view: "Ver Registro", hide: "Ocultar Registro", noActivities: "Nenhuma atividade de processamento registrada ainda", legalBasisLabel: "Base Legal", showMore: "Mostrar mais {{count}}", showLess: "Mostrar menos", gdprNote: "Nos termos do Artigo 30 do RGPD, você tem o direito de acessar os registros de todas as atividades de processamento de dados em sua conta.", activityTypes: { accountCreated: "Conta criada", profileUpdated: "Informações do perfil atualizadas", onboardingCompleted: "Integração concluída", achievementUnlocked: "Conquista desbloqueada", preferencesCreated: "Preferências de notificação definidas", preferencesUpdated: "Preferências de notificação atualizadas", notificationSent: "Notificação enviada", notificationRead: "Notificação lida", roleAssigned: "Função atribuída" }, legalBasis: { consent: "Consentimento", contractPerformance: "Execução do contrato", legitimateInterest: "Interesse legítimo" } } },
  progress: { title: "Maestria do Observatório", description: "Acompanhe sua jornada pelo Observatório", emailVerified: "Email verificado", visitedModules: "Visitou", modules: "módulos", setupComplete: "Configuração concluída", observer: "Observador", analyst: "Analista", visionary: "Visionário" },
  notifications: { title: "Notificações", empty: "Nenhuma notificação ainda", viewSettings: "Configurações de Notificação", markAllRead: "Marcar todas como lidas", preferences: "Preferências de Notificação", preferencesDescription: "Controle como você recebe briefings de inteligência", emailAlerts: "Alertas por Email", emailAlertsDescription: "Receba Briefings Estratégicos de Inteligência por email", inAppAlerts: "Alertas no App", inAppAlertsDescription: "Mostrar notificações toast ao fazer login", weeklyDigest: "Resumo Semanal", weeklyDigestDescription: "Receba um resumo de inteligência toda semana", intelBriefing: "📊 Nova Informação Disponível", deleteAll: "Excluir Todas", deleteAllConfirm: "Excluir Todas as Notificações?", deleteAllDescription: "Isso removerá permanentemente todo o seu histórico de notificações. Esta ação não pode ser desfeita.", deleteAllButton: "Excluir Todas as Notificações", deleted: "Notificações excluídas", deletedDescription: "Todas as suas notificações foram removidas permanentemente.", deleteError: "Falha ao excluir", deleteErrorDescription: "Não foi possível excluir as notificações. Tente novamente.", cancel: "Cancelar", deletedSingle: "Notificação excluída", swipeHint: "Deslize para a esquerda para excluir" },
  admin: { 
    sendBriefing: "Enviar Briefing de Inteligência", 
    sendBriefingDescription: "Envie um Briefing Estratégico de Inteligência para usuários inscritos", 
    module: "Módulo", 
    selectModule: "Selecione um módulo", 
    briefingTitle: "Título", 
    titlePlaceholder: "Ex: Novos Dados de Saúde Mental Divulgados", 
    summary: "Resumo", 
    summaryPlaceholder: "Breve descrição da nova inteligência...", 
    sendToSubscribers: "Enviar para Inscritos", 
    recipientNote: "Os destinatários são usuários com interesse principal correspondente que têm alertas por email ativados",
    fillAllFields: "Por favor, preencha todos os campos",
    briefingSent: "Briefing Enviado",
    sentTo: "Enviado para",
    subscribers: "inscritos",
    sendFailed: "Falha ao enviar briefing",
    briefingSentTo: "Briefing enviado para",
    users: "usuários",
    sending: "Enviando...",
    apiKeys: {
      title: "Chaves API",
      description: "Gerencie chaves API para acesso externo aos dados YFI",
      create: "Criar Chave API",
      createTitle: "Criar Nova Chave API",
      createDescription: "Crie uma nova chave API para software externo acessar a API de dados YFI.",
      name: "Nome",
      namePlaceholder: "Ex: Minha Aplicação",
      keyDescription: "Descrição",
      descriptionPlaceholder: "Para que esta chave será usada?",
      expiration: "Expiração",
      never: "Nunca expira",
      days30: "30 dias",
      days90: "90 dias",
      months6: "6 meses",
      year1: "1 ano",
      cancel: "Cancelar",
      creating: "Criando...",
      created: "Chave API Criada",
      createdDescription: "Sua nova chave API foi criada. Copie agora - ela não será mostrada novamente.",
      saveKeyWarning: "Salve sua chave API agora!",
      saveKeyDescription: "Esta é a única vez que você verá esta chave. Copie e armazene com segurança.",
      savedKey: "Salvei minha chave",
      revoke: "Revogar",
      revokeTitle: "Revogar Chave API",
      revokeDescription: "Tem certeza de que deseja revogar esta chave? Esta ação não pode ser desfeita. Aplicações usando esta chave perderão acesso imediatamente.",
      revoking: "Revogando...",
      revoked: "Chave API Revogada",
      revokedDescription: "A chave API foi revogada e não pode mais ser usada.",
      noKeys: "Nenhuma chave API ainda",
      noKeysDescription: "Crie sua primeira chave API para começar.",
      active: "Ativa",
      expired: "Expirada",
      created_at: "Criada",
      lastUsed: "Último uso",
      requests: "requisições",
      viewDocs: "Consulte o Guia de Integração API para documentação sobre o uso destas chaves.",
      failedToLoad: "Falha ao carregar chaves API",
      failedToCreate: "Falha ao criar chave API",
      failedToRevoke: "Falha ao revogar chave API"
    },
    dataAdmin: {
      title: "Administração de Dados",
      description: "Monitore e gerencie os dados do observatório",
      refresh: "Atualizar",
      coverage: "Cobertura de Perfis de País",
      coverageDescription: "dos países têm perfis detalhados",
      databaseTables: "Tabelas do Banco de Dados",
      yfiCountries: "Países YFI",
      yfiCountriesDesc: "Países com pontuações YFI",
      countryProfiles: "Perfis de País",
      countryProfilesDesc: "Dados detalhados por país",
      jciStats: "Estatísticas JCI",
      jciStatsDesc: "Métricas organizacionais globais",
      regions: "Regiões",
      regionsDesc: "Regiões JCI",
      activeApiKeys: "Chaves API Ativas",
      activeApiKeysDesc: "Acesso de software externo",
      apiRequests: "Requisições API",
      apiRequestsDesc: "Total de requisições registradas",
      countryProfilesTitle: "Perfis de País",
      published: "publicados",
      draft: "Rascunho",
      updated: "Atualizado",
      noProfiles: "Nenhum perfil de país criado ainda",
      quickActions: "Ações Rápidas",
      viewYfiRankings: "Ver Rankings YFI",
      regionalAnalysis: "Análise Regional",
      backendNote: "Para gerenciamento avançado do banco de dados, acesse o painel do Lovable Cloud nas configurações do projeto."
    }
  },
  featuredInsight: { title: "Seu País de Foco", fiiScore: "Índice de Futuros da Juventude", globalAverage: "Média Global", viewFullRankings: "Ver Índice Completo", unlockTitle: "Desbloqueie Seus Insights Personalizados", unlockDescription: "Complete a configuração para ver como seu país de foco se compara à média global em todas as dimensões do YFI." },
  roles: { admin: "Administrador", administrator: "Administrador", moderator: "Moderador", user: "Usuário" },
  interests: { "mental health": "Saúde Mental", "mental-health": "Saúde Mental", "workforce preparation": "Preparação da Força de Trabalho", "workforce-preparation": "Preparação da Força de Trabalho", "entrepreneurship": "Empreendedorismo", "technology adoption": "Adoção de Tecnologia", "technology-adoption": "Adoção de Tecnologia", "regional analysis": "Análise Regional", "regional-analysis": "Análise Regional" },
  mastery: { observer: "Observador", analyst: "Analista", visionary: "Visionário" },
  visibility: { membersOnly: "APENAS MEMBROS", adminOnly: "APENAS ADMIN", hiddenAdminOnly: "OCULTO (apenas admin)" },
  header: { title: "Observatório de Futuros da Juventude dos Conselhos de Desenvolvimento JCI", subtitle: "Observatório Global dos Conselhos de Desenvolvimento", tagline: "Desenvolvendo Líderes para um Mundo em Mudança" },
  common: { jan: "Jan", feb: "Fev", mar: "Mar", apr: "Abr", may: "Mai", jun: "Jun", jul: "Jul", aug: "Ago", sep: "Set", oct: "Out", nov: "Nov", dec: "Dez", preferredProgramTypes: "Tipos de Programa Preferidos", preferredEventFormat: "Formato de Evento Preferido", regionalPreferences: "Preferências Regionais", inPerson: "Presencial", online: "Online", hybrid: "Híbrido", networking: "Networking", development: "Desenvolvimento", leadership: "Liderança", search: "Pesquisar", settings: "Configurações", signIn: "Entrar", signOut: "Sair", toggleMenu: "Alternar menu de navegação", scrollToTop: "Rolar para o topo", source: "Fonte", sources: { membership2025: "Membros JCI 2025", impactReport2025: "Relatório de Impacto JCI 2025" }, loading: "Carregando...", noDataAvailable: "Dados não disponíveis", noDataDescription: "Os dados estão sendo carregados ou não estão disponíveis no momento.", errorLoadingChart: "Erro ao carregar gráfico", months: { jan: "Jan", feb: "Fev", mar: "Mar", apr: "Abr", may: "Mai", jun: "Jun", jul: "Jul", aug: "Ago", sep: "Set", oct: "Out", nov: "Nov", dec: "Dez" } },
  ui: { notFound: { title: "404", message: "Ops! Página não encontrada", returnHome: "Voltar para Início" }, keyboardShortcuts: { title: "Atalhos de Teclado", toggleDarkMode: "Alternar modo escuro/claro", cycleLanguages: "Alternar idiomas", openSearch: "Abrir pesquisa", showShortcuts: "Mostrar atalhos de teclado", ctrlOrCmd: "Use Ctrl no Windows/Linux ou ⌘ no Mac" }, commandPalette: { searchPlaceholder: "Pesquisar páginas...", noResults: "Nenhum resultado encontrado.", pagesHeading: "Páginas" }, languageToggle: { selectLanguage: "Selecionar idioma", changeLanguage: "Alterar idioma" } },
  charts: { noDataAvailable: "Dados não disponíveis", dataLoadingSoon: "Os dados serão carregados em breve", noFunnelData: "Dados de funil não disponíveis", configureProcessData: "Configure os dados do processo", radarUnavailable: "Dados de radar não disponíveis", configurePerformanceIndicators: "Configure indicadores de desempenho", performanceUnavailable: "Dados de desempenho não disponíveis", configureTrendData: "Configure dados de tendência", currentProgress: "Progresso Atual", goal2040: "Meta 2040", mainValue: "Valor Principal", trend: "Tendência", goal: "Meta", fiiScore: "Pontuação FII", score: "Pontuação", value: "Valor", percentage: "Porcentagem", region: "Região", country: "País", members: "Membros", year: "Ano", month: "Mês", count: "Contagem", total: "Total", current: "Atual", projected: "Projetado", average: "Média" },
  metrics: { membersActive: "Membros Ativos", countriesPresent: "Países Presentes", startupsSupported: "Startups Apoiadas", sustainableProjects: "Projetos Sustentáveis", completed: "concluído", countries: "Países", members: "Membros", projects: "Projetos", projectsPerYear: "Projetos/ano", memberDensity: "Densidade de Membros", country: "País", regionalDistribution: "Distribuição Regional", globalPresence: "Presença global da JCI em 2025", activeMembers: "Membros Ativos", globally: "globalmente", worldwidePresence: "presença mundial", communities: "Comunidades", activeCommunities: "comunidades ativas", yearsOfHistory: "Anos de História", since1915: "desde 1915", vs2024: "vs 2024", annualProjects: "Projetos Anuais", in2025: "em 2025" },
  index: { heroTitle: "Observatório de Futuros da Juventude dos Conselhos de Desenvolvimento JCI", heroSubtitle: "Medindo Liderança Jovem, Saúde Mental e Oportunidade Econômica Globalmente", heroDescription: "Uma plataforma orientada por dados analisando as condições para jovens líderes em 114 países. Usando métricas verificadas da rede global da JCI e parcerias de pesquisa.", globalImpactTitle: "Impacto Global em Resumo", verifiedData: "Dados verificados do Relatório de Impacto JCI 2025", globalMembers: "Membros Globais", activeWorldwide: "Ativos mundialmente", projects: "Projetos", period20242025: "Período: 2024-2025", volunteerHours: "Horas de Voluntariado", hoursContributed: "Horas contribuídas", countries: "Países", worldwidePresence: "Presença mundial", localOrganizations: "Organizações Locais", activeCommunities: "Comunidades ativas", digitalReachTitle: "Alcance e Pegada Digital", totalFollowers: "Seguidores Totais", jciccUsers: "Usuários jci.cc", memberDemographicsTitle: "Instantâneo de Demografia de Membros", averageAge: "Idade Média", yearsOld: "Anos", universityEducated: "Educação Universitária", bachelorsOrHigher: "Bacharelado ou superior", fullTime: "Tempo integral", entrepreneurs: "Empreendedores", employmentStatus: "Status de Emprego" },
  globalPresenceMap: {
    title: "Presença Global JCI",
    subtitle: "Ativo em 114 Países em 4 Regiões",
    countriesLabel: "países",
    regionsLabel: "regiões",
    countriesCount: "Países",
    membersCount: "Membros",
    localOrgs: "Orgs Locais",
    regions: {
      asiaPacific: "Ásia e o Pacífico",
      europe: "Europa",
      africaMe: "África e Oriente Médio",
      americas: "América"
    }
  },
  mentalHealth: {
    serviceCoverageGap: "Lacuna de cobertura de serviços de 30-40% entre EUA/Canadá e América Latina",
    criticalGap: "Lacuna crítica: apenas 10-30% de cobertura de serviços vs 70%+ na Europa",
    onlyTrained: "(apenas {percentage}% treinados)"
  },
  memberInsights: {
    alumniInsight: "53% dos novos membros (1-3 anos) trazem energia fresca enquanto 24% dos veteranos (7+ anos) fornecem liderança central e estabilidade"
  },
  onboarding: {
    commandCenterSetup: "Configuração do Centro de Comando",
    stepOf: "Passo {{current}} de {{total}}",
    continue: "Continuar",
    back: "Voltar",
    completeSetup: "Concluir Configuração",
    preferencesUpdated: "Preferências Atualizadas",
    lensUpdated: "Sua lente do observatório foi atualizada.",
    error: "Erro",
    saveFailed: "Falha ao salvar suas preferências. Tente novamente.",
    identity: {
      title: "Confirme Sua Identidade",
      description: "Diga-nos quem você é e a qual organização JCI você pertence.",
      fullName: "Nome Completo",
      fullNamePlaceholder: "Digite seu nome completo",
      nationalOrg: "Organização Nacional JCI",
      nationalOrgPlaceholder: "Selecione sua organização nacional...",
      searchCountry: "Pesquisar país...",
      noCountryFound: "Nenhum país encontrado.",
      localOrg: "Organização Local JCI",
      optional: "Opcional",
      localOrgPlaceholder: "Ex: JCI São Paulo, JCI Rio de Janeiro"
    },
    lens: {
      title: "Escolha Sua Lente",
      description: "Selecione sua principal área de interesse. Isso personalizará sua experiência no painel.",
      mentalHealth: "Saúde Mental",
      mentalHealthDesc: "Foco em bem-estar psicológico, resiliência e iniciativas de saúde mental.",
      education: "Educação e Força de Trabalho",
      educationDesc: "Explore resultados de aprendizagem, desenvolvimento de habilidades e tendências de emprego.",
      entrepreneurship: "Empreendedorismo",
      entrepreneurshipDesc: "Descubra a saúde do ecossistema de negócios, atividade de startups e métricas de inovação."
    },
    benchmark: {
      title: "Defina Seu Benchmark",
      description: "Escolha um país de foco para comparar com a Média Global do YFI em todo o painel.",
      focusCountry: "País de Foco",
      focusCountryPlaceholder: "Selecione seu país de foco...",
      searchCountry: "Pesquisar país...",
      noCountryFound: "Nenhum país encontrado.",
      vsGlobal: "{{country}} vs Média Global",
      globalAverage: "Média Global",
      aboveAverage: "+{{value}} acima da média global",
      belowAverage: "-{{value}} abaixo da média global"
    },
    config: {
      ready: "Pronto para Lançar!",
      configuring: "Configurando Seu Centro de Comando",
      step1: "Analisando suas preferências...",
      step2: "Configurando layout do painel...",
      step3: "Carregando insights personalizados...",
      step4: "Preparando seu Centro de Comando..."
    }
  },
  fiiClassifications: {
    excellent: "Excelente",
    good: "Bom",
    moderate: "Moderado",
    deficient: "Deficiente",
    critical: "Crítico"
  },
  regions: {
    asiaPacific: "Ásia e o Pacífico",
    europe: "Europa",
    americas: "América",
    africaMiddleEast: "África e Oriente Médio"
  },
  access: {
    exclusiveMemberInsight: "Insight Exclusivo para Membros",
    adminOnlyModule: "Módulo Apenas para Administradores",
    joinCTA: "Junte-se ao Observatório de Futuros da Juventude dos Conselhos de Desenvolvimento JCI para desbloquear o banco de dados completo, insights e projeções.",
    adminOnlyMessage: "Este conteúdo {{moduleLabel}} está disponível apenas para administradores.",
    joinNowLogin: "Junte-se Agora / Entrar",
    backToDashboard: "Voltar ao Painel",
    memberAccess: "Acesso de Membros",
    passwordlessEntry: "Entrada sem senha com Magic Link ou Google.",
    joinObservatory: "Junte-se ao Observatório",
    unlockDescription: "Desbloqueie insights exclusivos para membros, projeções e módulos interativos.",
    email: "E-mail",
    emailPlaceholder: "voce@empresa.com",
    sendMagicLink: "Enviar Magic Link",
    continueWithGoogle: "Continuar com Google",
    authDisclaimer: "Ao continuar, você concorda em receber e-mails de autenticação.",
    signingIn: "Entrando...",
    checkInbox: "Verifique sua caixa de entrada",
    magicLinkSent: "Enviamos um link mágico seguro para você fazer login.",
    invalidEmail: "E-mail inválido",
    invalidEmailDescription: "Por favor, insira um endereço de e-mail válido.",
    loginFailed: "Falha no login",
    googleLoginFailed: "Falha no login do Google"
  },
  chatJCI: {
    title: "ChatJCI",
    openChat: "Abrir chat",
    closeChat: "Fechar chat",
    placeholder: "Digite sua pergunta...",
    send: "Enviar mensagem",
    thinking: "Pensando...",
    greeting: "Olá, {{name}}! Como posso ajudá-lo hoje?",
    defaultName: "você",
    fallbackMessage: "Desculpe, não consegui encontrar essa informação na minha base de conhecimento.",
    errorMessage: "Desculpe, algo deu errado. Por favor, tente novamente.",
    rateLimitMessage: "Muitas solicitações. Por favor, aguarde um momento antes de tentar novamente.",
    authRequired: "Por favor, faça login para usar o ChatJCI.",
    welcomeSubtitle: "Pergunte-me qualquer coisa sobre programas JCI, associação ou Visão 2040",
    newChat: "Nova Conversa",
    poweredBy: "Desenvolvido por Google Gemini",
    suggestedPrompts: {
      title: "Experimente perguntar sobre:",
      vision2040: "O que é a Visão 2040 da JCI?",
      risePrograms: "Fale-me sobre os programas JCI RISE",
      membership: "Como posso me tornar membro da JCI?",
      councils: "O que são os Conselhos de Desenvolvimento?",
      youthIndex: "Explique o Índice de Futuros da Juventude"
    },
    loginRequired: {
      title: "Entre para Conversar",
      description: "O ChatJCI está disponível exclusivamente para membros da JCI. Faça login para iniciar uma conversa.",
      action: "Entrar"
    },
    locked: {
      title: "Assistente de IA Exclusivo para Membros",
      description: "O ChatJCI é seu guia pessoal de IA para programas JCI, Visão 2040 e o Índice de Futuros da Juventude. Faça login para iniciar uma conversa."
    },
    sidebar: {
      newChat: "Nova Conversa",
      today: "Hoje",
      yesterday: "Ontem",
      last7Days: "Últimos 7 Dias",
      older: "Anteriores",
      noConversations: "Sem conversas ainda",
      searchPlaceholder: "Pesquisar conversas...",
      noResults: "Nenhuma conversa encontrada",
      deleteConversation: "Excluir conversa?",
      deleteConfirmation: "Isso excluirá permanentemente esta conversa e todas as suas mensagens.",
      delete: "Excluir",
      renameConversation: "Renomear",
      exportAll: "Exportar Todas as Conversas"
    },
    export: {
      asJson: "Exportar como JSON",
      asMarkdown: "Exportar como Markdown",
      downloading: "Preparando download...",
      success: "Conversas exportadas",
      singleSuccess: "Conversa exportada",
      successDescription: "Seu histórico de chat foi baixado com sucesso",
      error: "Falha na exportação",
      errorDescription: "Não foi possível exportar as conversas. Tente novamente.",
      noConversations: "Sem conversas para exportar"
    },
    copy: {
      tooltip: "Copiar para área de transferência",
      success: "Conversa copiada",
      successDescription: "Markdown copiado. Cole em qualquer lugar!",
      error: "Falha ao copiar",
      errorDescription: "Não foi possível copiar. Tente novamente.",
      noMessages: "Sem mensagens para copiar"
    },
    share: {
      button: "Compartilhar",
      dialogTitle: "Compartilhar Conversa",
      dialogDescription: "Qualquer pessoa com este link pode ver esta conversa.",
      createLink: "Criar Link de Compartilhamento",
      generating: "Gerando link...",
      created: "Link criado",
      createdDescription: "Sua conversa agora pode ser compartilhada",
      linkCopied: "Link copiado",
      copyError: "Falha ao copiar link",
      revokeShare: "Revogar Compartilhamento",
      revoked: "Compartilhamento revogado",
      revokedDescription: "Este link não funcionará mais",
      revokeError: "Falha ao revogar",
      createError: "Falha ao criar compartilhamento",
      createErrorDescription: "Não foi possível criar o link. Tente novamente.",
      publicNote: "Qualquer pessoa com o link pode ver esta conversa",
      viewCount: "{{count}} visualizações",
      views: "visualizações",
      expiresAt: "Expira em {{date}}",
      expirationLabel: "O link expira em",
      days7: "7 dias",
      days30: "30 dias",
      days90: "90 dias"
    },
    sharedView: {
      title: "Conversa ChatJCI Compartilhada",
      sharedBy: "Compartilhado por Membro JCI",
      sharedOn: "Compartilhado em {{date}}",
      signUpCta: "Quer seu próprio assistente de IA?",
      signUpButton: "Cadastre-se no ChatJCI",
      notFound: "Conversa não encontrada",
      notFoundDescription: "Este link pode ter expirado ou sido revogado.",
      expired: "Este link expirou"
    },
    message: {
      copy: "Copiar",
      copied: "Copiado!",
      regenerate: "Regenerar",
      edit: "Editar",
      stopGenerating: "Parar",
      editPlaceholder: "Edite sua mensagem...",
      cancel: "Cancelar",
      saveAndSubmit: "Salvar e Enviar"
    },
    streaming: {
      generating: "Gerando...",
      stopped: "Parado"
    }
  },
  errorBoundary: {
    title: "Algo deu errado",
    description: "Pedimos desculpas pelo inconveniente. Ocorreu um erro inesperado.",
    tryAgain: "Tentar Novamente",
    goHome: "Ir para Início",
    errorDetails: "Detalhes do Erro (Apenas Desenvolvimento)",
    helpText: "Se este problema persistir, por favor, atualize a página ou entre em contato com o suporte.",
    chunkLoadError: {
      title: "Falha ao Carregar Página",
      description: "A página não pôde ser carregada. Isso pode ser devido a um problema de rede ou cache desatualizado.",
      retry: "Tentar Novamente",
      retryMessage: "Tentativa {{current}} de {{max}}",
      maxRetries: "Máximo de tentativas de repetição atingido."
    }
  },
  gdpr: {
    cookieTitle: "Preferências de Cookies",
    cookieDescription: "Usamos cookies para analisar o uso do site e melhorar sua experiência. Seus dados nunca são vendidos a terceiros.",
    learnMore: "Saiba mais sobre nossas práticas de privacidade",
    accept: "Aceitar",
    decline: "Recusar",
    analyticsTitle: "Analytics e Cookies",
    analyticsDescription: "Gerencie como usamos cookies e analytics para melhorar sua experiência",
    allowAnalytics: "Permitir Analytics",
    allowAnalyticsDescription: "Ajude-nos a melhorar compartilhando dados anônimos de uso",
    analyticsEnabled: "Analytics Ativado",
    analyticsEnabledDescription: "Agora você pode nos ajudar a melhorar a plataforma com dados anônimos de uso.",
    analyticsDisabled: "Analytics Desativado",
    analyticsDisabledDescription: "Seus dados de uso não serão mais coletados.",
    whatWeCollect: "O que coletamos:",
    collectItem1: "Visualizações de página e padrões de navegação",
    collectItem2: "Engajamento de recursos e profundidade de rolagem",
    collectItem3: "Informações anônimas de dispositivo e navegador",
    neverCollect: "Nunca coletamos informações pessoais ou vendemos seus dados a terceiros."
  },
  apiDocs: {
    badge: "API para Desenvolvedores",
    hero: {
      title: "API do Observatório de Futuros da Juventude",
      subtitle: "Acesse dados abrangentes sobre desenvolvimento juvenil de 114 países. Crie aplicações, visualizações e integre métricas YFI em seus projetos.",
      getAccess: "Obter Acesso à API",
      viewDocs: "Ver Especificação OpenAPI"
    },
    stats: {
      countries: "Países",
      statistics: "Estatísticas",
      endpoints: "Endpoints"
    },
    features: {
      badge: "Por Que Usar Nossa API",
      title: "Feito para Desenvolvedores",
      subtitle: "Nossa API fornece acesso confiável e bem documentado a métricas abrangentes de desenvolvimento juvenil. Seja construindo ferramentas de pesquisa, dashboards ou visualizações de dados — nós temos o que você precisa.",
      sampleRequest: "Exemplo de Requisição",
      restful: {
        title: "API RESTful JSON",
        description: "Endpoints REST padrão retornando respostas JSON limpas e previsíveis. Fácil integração com qualquer linguagem de programação ou plataforma."
      },
      filtering: {
        title: "Filtragem Abrangente",
        description: "Filtre dados por região, classificação, faixas de pontuação e mais. Obtenha exatamente os dados que precisa com parâmetros de consulta poderosos.",
        highlight: "15+ Filtros"
      },
      pagination: {
        title: "Paginação e Ordenação",
        description: "Manipule grandes conjuntos de dados eficientemente com paginação integrada. Ordene por qualquer campo em ordem crescente ou decrescente.",
        highlight: "Baseado em Offset"
      },
      auth: {
        title: "Chaves API Seguras",
        description: "Chaves com hash SHA-256 com limites de taxa por chave. Gere, revogue e monitore chaves no seu painel."
      },
      logging: {
        title: "Registro de Requisições",
        description: "Analytics completo do uso da sua API. Acompanhe contagens de requisições, tempos de resposta e taxas de erro em tempo real.",
        highlight: "Analytics"
      },
      cors: {
        title: "CORS Habilitado",
        description: "Requisições cross-origin suportadas nativamente. Construa aplicações baseadas em navegador sem servidores proxy."
      }
    },
    auth: {
      badge: "Segurança",
      title: "Autenticação",
      subtitle: "Todas as requisições API requerem autenticação via chave API. Siga estes passos simples para começar.",
      step1: {
        title: "Obtenha Sua Chave API",
        description: "Navegue até Configurações e gere uma nova chave API. Dê um nome descritivo para fácil gerenciamento."
      },
      step2: {
        title: "Adicione aos Headers",
        description: "Inclua sua chave API no header X-API-Key em cada requisição que fizer para nossos endpoints."
      },
      step3: {
        title: "Comece a Construir",
        description: "Você está pronto! Faça requisições para qualquer endpoint e comece a integrar dados YFI na sua aplicação."
      },
      headerExample: "Formato do Header"
    },
    endpoints: {
      badge: "Referência da API",
      title: "Endpoints Disponíveis",
      subtitle: "Três endpoints poderosos para acessar todos os dados YFI. Cada endpoint suporta filtragem, ordenação e paginação.",
      parameters: "Parâmetros de Consulta",
      sampleRequest: "Exemplo de Requisição",
      sampleResponse: "Exemplo de Resposta",
      yfi: {
        title: "Rankings YFI",
        description: "Acesse pontuações e rankings do Youth Futures Index para todos os países. Filtre por região, classificação, ordene por qualquer dimensão e pagine resultados."
      },
      countries: {
        title: "Perfis de Países",
        description: "Dados detalhados por país incluindo demografia, presença JCI, indicadores de saúde mental, dados de força de trabalho e métricas de empreendedorismo."
      },
      stats: {
        title: "Estatísticas Globais",
        description: "Estatísticas agregadas da JCI incluindo contagem de membros, distribuição regional, métricas organizacionais e dados históricos."
      },
      indicators: {
        title: "Metadados de Indicadores",
        description: "Obtenha definições detalhadas, metodologias e limiares para todos os indicadores YFI. Sem autenticação necessária."
      },
      benchmarks: {
        title: "Benchmarks Regionais",
        description: "Benchmarks estatísticos por região incluindo média, mediana, percentis e países de melhor desempenho."
      }
    },
    params: {
      yfi: {
        region: "Filtrar por região JCI: amdec, adc, apdc, edc",
        classification: "Filtrar por nível YFI: Excellent, Good, Moderate, Deficient, Critical",
        code: "Obter país específico por código ISO de 2 letras (ex: BR, DE, JP)",
        sort: "Campo de ordenação: yfi_score, mental_health_score, workforce_score, entrepreneurship_score, country_name",
        order: "Direção da ordenação: asc (crescente) ou desc (decrescente)",
        limit: "Resultados por página (padrão: 100, máx: 1000)",
        offset: "Offset de paginação para buscar páginas subsequentes",
        countryCodes: "Filtrar múltiplos países por códigos ISO separados por vírgula (ex: BR,DE,JP)",
        fields: "Retornar apenas campos específicos (ex: country_code,yfi_score,classification)"
      },
      countries: {
        slug: "Identificador do perfil do país (ex: brazil, germany)"
      },
      stats: {
        key: "Obter estatística específica por seu identificador único",
        category: "Filtrar por categoria: membership, regional, organizational"
      },
      indicators: {
        key: "Filtrar por chave específica do indicador (ex: YFI_SCORE, YFI_MENTAL)",
        category: "Filtrar por categoria do indicador: composite, mental_health, workforce, entrepreneurship",
        lang: "Código de idioma para nomes/descrições traduzidos (ex: pt, es, fr, ja)"
      },
      benchmarks: {
        region: "Código da região para benchmarks regionais: amdec, adc, apdc, edc",
        indicator: "Indicador específico para benchmark: yfi_score, mental_health_score, workforce_score, entrepreneurship_score",
        top: "Número de países com melhor desempenho para incluir (padrão: 5)"
      }
    },
    table: {
      parameter: "Parâmetro",
      type: "Tipo",
      description: "Descrição"
    },
    responseFormat: {
      title: "Formato de Resposta",
      subtitle: "Todos os endpoints retornam uma estrutura JSON consistente com dados e metadados.",
      structure: "Estrutura de Resposta Padrão",
      success: {
        title: "Array de Dados",
        description: "Resultados são retornados no campo 'data' como um array (ou objeto para requisições de item único)."
      },
      meta: {
        title: "Metadados Incluídos",
        description: "Cada resposta inclui info de paginação, ID da requisição para debug e timestamp."
      }
    },
    errors: {
      title: "Tratamento de Erros",
      subtitle: "A API usa códigos de status HTTP padrão. Aqui estão as respostas de erro mais comuns que você pode encontrar.",
      "401": {
        title: "Não Autorizado",
        description: "Chave API ausente, inválida ou revogada. Verifique seu header X-API-Key."
      },
      "404": {
        title: "Não Encontrado",
        description: "O recurso solicitado não existe. Verifique o caminho do endpoint e parâmetros de consulta."
      },
      "405": {
        title: "Método Não Permitido",
        description: "Apenas requisições GET são suportadas. Certifique-se de usar o método HTTP correto."
      },
      "429": {
        title: "Limite de Taxa Excedido",
        description: "Você excedeu seu limite de taxa. Aguarde o período de reset ou aumente os limites da sua chave."
      },
      "500": {
        title: "Erro do Servidor",
        description: "Ocorreu um erro inesperado. Entre em contato com o suporte informando seu request_id."
      }
    },
    useCases: {
      title: "Casos de Uso",
      subtitle: "Veja como organizações estão usando dados YFI para gerar impacto.",
      research: {
        title: "Pesquisa Acadêmica",
        description: "Universidades e instituições de pesquisa usam dados YFI para estudos comparativos sobre desenvolvimento juvenil."
      },
      journalism: {
        title: "Jornalismo de Dados",
        description: "Organizações de notícias criam visualizações e histórias impactantes sobre tendências globais da juventude."
      },
      ngo: {
        title: "Planejamento de ONGs",
        description: "Organizações sem fins lucrativos usam insights regionais para planejar intervenções e alocar recursos efetivamente."
      },
      policy: {
        title: "Análise de Políticas",
        description: "Agências governamentais analisam métricas YFI para informar decisões de políticas voltadas à juventude."
      }
    },
    quickStart: {
      title: "Início Rápido",
      subtitle: "Faça sua primeira requisição API em segundos. Copie este comando cURL e substitua com sua chave API."
    },
    copy: "Copiar",
    copied: "Copiado!",
    codeCopied: "Código copiado para a área de transferência",
    copyFailed: "Falha ao copiar código",
    cta: {
      title: "Pronto para Construir?",
      subtitle: "Gere sua chave API e comece a construir com dados YFI hoje. Sem necessidade de cartão de crédito.",
      button: "Obter Sua Chave API"
    }
  }
} as const;

